module.exports = __webpack_public_path__ + "clock.png?c77840c3eab3e3fee86acbb8bfed7ec8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point-register/clock.png
// module id = 994
// module chunks = 0